<template>
  <section
    v-show="show"
    class="no-signal-container">
    <img
      class="error-icon"
      :src="noSignalIcon"
      alt="No Signal">
    <h1 class="error-title">No Signal</h1>
    <p class="error-text">Invalid ByteArk Signal URL</p>
  </section>
</template>

<script>
const noSignalIcon = require('@/assets/images/icons/no-signal.svg');

export default {
  data() {
    return {
      noSignalIcon,
      show: false,
    };
  },
  created() {
    setTimeout(() => { this.show = true; }, 800);
  },
};
</script>

<style lang="scss" scoped>
.no-signal-container {
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  .error-icon {
    width: 130px;
    margin-bottom: 10px;
  }
  .error-title {
    animation: blinkingText 1200ms ease infinite;
  }
  .error-text {
    color: #CDCDCD;
  }
}

@keyframes blinkingText{
  0% {
    color: #b8b8be;
  }
  49% {
    color: #6e6e75;
  }
  50% {
    color: #6e6e75;
  }
  99% {
    color: #6e6e75;
  }
  100% {
    color: #b8b8be;
  }
}
</style>
